import React from 'react';

export default function WhoAreYou() {
  const styles = {
    li: {
      margin: '30px',
      fontSize: '1.2em'
    },
    question: {
      fontSize: '1.1em',
      marginBottom: '15px'
    }
  };

  return (
    <>
      <section id="who-are-you" data-auto-animate>
        <h1>Tour De Table</h1>
        <h3>Présentons-nous !</h3>
        <ul>
          <li style={styles.li}>
            <span style={styles.question}>
              <span role="img" aria-label="Wave">
                👋
              </span>{' '}
              Nom / Prénom
            </span>
          </li>
          <li style={styles.li}>
            <span style={styles.question}>
              <span role="img" aria-label="Graduation cap">
                🎓
              </span>{' '}
              Formation Initiale / Alternance ?
            </span>
          </li>
          <li style={styles.li}>
            <span style={styles.question}>
              <span role="img" aria-label="Computer">
                💻
              </span>{' '}
              Niveau <strong>Cyber/Réseau/Dev</strong> ?
            </span>
            <br />
            <small style={{ color: '#888' }}>
              (Débutant, Intermédiaire, Avancé)
            </small>
          </li>
          <li style={styles.li}>
            <span style={styles.question}>
              <span role="img" aria-label="Thinking face">
                🤔
              </span>{' '}
              Difficultés rencontrées ?
            </span>
          </li>
          <li style={styles.li}>
            <span style={styles.question}>
              <span role="img" aria-label="Target">
                🎯
              </span>{' '}
              Attentes pour ce module ?
            </span>
          </li>
        </ul>
      </section>

      <section id="who-are-you" data-auto-animate>
        <h1>Tour De Table</h1>
        <h3>Présentons-nous !</h3>
        <ul>
          <li style={styles.li}>
            <span style={styles.question}>
              <span role="img" aria-label="Wave">
                👋
              </span>{' '}
              Nom / Prénom
            </span>
          </li>
          <li style={styles.li}>
            <span style={styles.question}>
              <span role="img" aria-label="Graduation cap">
                🎓
              </span>{' '}
              Formation Initiale / Alternance ?
            </span>
          </li>
          <li style={styles.li}>
            <span style={styles.question}>
              <span role="img" aria-label="Computer">
                💻
              </span>{' '}
              Niveau <strong>Cyber/Réseau/Dev</strong> ?
            </span>
            <br />
            <small style={{ color: '#888' }}>
              (Débutant, Intermédiaire, Avancé)
            </small>
          </li>
          <li style={styles.li}>
            <span style={styles.question}>
              <span role="img" aria-label="Thinking face">
                🤔
              </span>{' '}
              Difficultés rencontrées ?
            </span>
          </li>
          <li style={styles.li}>
            <span style={styles.question}>
              <span role="img" aria-label="Target">
                🎯
              </span>{' '}
              Attentes pour ce module ?
            </span>
          </li>
        </ul>

        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          <h4 style={{ color: '#ff6b6b' }}>
            <span role="img" aria-label="Light bulb">
              💡
            </span>{' '}
            <strong>Bonus :</strong> Une anecdote cybersécurité que vous
            connaissez ?
          </h4>
        </div>
      </section>
    </>
  );
}
